import React from "react"
import Layout from "../components/layout"
import { Link } from 'gatsby'
import ChatBox from "../components/chatBox"

const ChatPage = ({
}) => {

  return (
    <Layout>
      <div className="chatbox"><ChatBox/></div>
      <Link to='/' className="button -primary">&larr; Back to posts</Link>
    </Layout>
  )
}

export default ChatPage